import ValidityHint from '@lib/enums/validityHint';
import { CollapseCropColor } from '@lib/components/Collapse/Collapse';

export default function getCropColorByValidityHint(
  validityHint?: string | null,
): CollapseCropColor {
  if (validityHint === ValidityHint.Failure) {
    return CollapseCropColor.Error;
  }
  if (validityHint === ValidityHint.Warning) {
    return CollapseCropColor.Warning;
  }
  return CollapseCropColor.White;
}
